// Match compiler display budgets without truncating authored or translated content.
export const characterCount = value => Array.from(value || '').length;
export function flowFieldErrors(record, questionnaire, kind) {
  const errors = [];
  const languages = [...new Set(['en', ...(questionnaire?.languages || [])])];
  const check = (field, label, limit, fallback = '') => {
    const base = record[field] || fallback;
    for (const language of languages) {
      const value = (language !== 'en' && record.translations?.[field]?.[language]) || base;
      const count = characterCount(value);
      if (typeof value !== 'string' || !value.trim() || count > limit) {
        errors.push(`${label} (${language}): use 1–${limit} characters for WhatsApp Flows (${count}/${limit}).`);
      }
    }
  };
  if (kind === 'question') {
    if (record.whatsAppCompatible === false) return errors;
    if (record.questionType !== 'location') check('question', 'Question text', 4096);
    // Generated Q labels are independent of authored tags and translations.
  } else if (kind === 'section') {
    // Generated section titles are centrally translated and bounded.
  } else if (record.whatsappMenuVisible || record.whatsappShareVisible) {
    check('name', 'Questionnaire name', 30);
    check('description', 'Questionnaire description', 300);
  }
  return errors;
}
